import "./App.css";
import About from "./components/about/About";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import Services from "./components/services/Services";
import Skills from "./components/skills/Skills";
import Qualifications from "./components/qualifications/Qualifications";
import Testmonials from "./components/testmonials/Testmonials";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Scrollup from "./components/scrollup/Scrollup";
import { useRef } from "react";
import { motion } from "framer-motion";



function App() {
  const scrollRef = useRef(null)
  return (
    <div ref={scrollRef} style={{ overflow: "scroll" }}>
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ root: scrollRef }}
    >

      <div className="App">
        <Header />
        <main className="main">
            <Home />
            <About />       
              <Skills />
              <Services />
            <Qualifications />
            <Testmonials />
            <Contact />
        </main>
        <Footer />
        <Scrollup />
      </div>
      </motion.div>
  </div>
  );
}

export default App;
